export const SORT_TIME_DESC = 1;
export const SORT_TIME_ASC = 2;
export const SORT_LEAGUE_AZ = 3;
export const SORT_TOP_LEAGUES = 4;



// WEBPACK FOOTER //
// ./src/HOCs/Constants/SortTypes.js